import Button from "@pathwright/ui/src/components/button/Button"
import { embedIframelyURL } from "@pathwright/ui/src/components/embed/utils"
import PropTypes from "prop-types"
import "./ContentMethodEmbedLink.css"

// This component is a custom form input.
// Use with ConnectForm. See lib/core/components/form for spec.

const ContentMethodEmbedLink = function (props) {
  const { value, placeholder, load_prompt, onLoad, onChange, onError } = props

  // Becomes ref to input so button can access value
  let input = null

  const handleLoad = function (e) {
    e.preventDefault()
    return embedIframelyURL(input.value)
      .then((result) =>
        onLoad(
          {
            embed_code: result.html,
            embed_link: input.value
          },
          props
        )
      )
      .catch((err) =>
        typeof onError === "function" ? onError(err) : undefined
      )
  }

  const handleEnterKey = function (e) {
    if (e.keyCode === 13) {
      return handleLoad(e)
    }
  }

  return (
    <div className="ContentMethod__EmbedLink">
      <input
        ref={(node) => {
          return (input = node)
        }}
        placeholder={placeholder}
        value={(value != null ? value.embed_link : undefined) || ""}
        onKeyDown={handleEnterKey}
        onChange={(e) => onChange(e.target.value)}
      />
      <Button onClick={handleLoad} rounded={false}>
        {load_prompt}
      </Button>
    </div>
  )
}

ContentMethodEmbedLink.displayName = "ContentMethodEmbedLink"

ContentMethodEmbedLink.propTypes = {
  // Customize load button text
  load_prompt: PropTypes.string.isRequired,
  // value is object
  value: PropTypes.shape({
    embed_link: PropTypes.string,
    embed_code: PropTypes.string
  }),
  // Pass up value
  onChange: PropTypes.func.isRequired,
  // Pass up { embed_code, embed_link } = value
  onLoad: PropTypes.func.isRequired
}

ContentMethodEmbedLink.defaultProps = {
  placeholder: "Paste link...",
  load_prompt: "Load"
}

export default ContentMethodEmbedLink
